// Чей протокол собирается. Задача протокола живёт в localStorage дольше экрана
// (переживает перезагрузку), и без владельца её результат ложился в ту запись,
// которая открыта в момент готовности, а не в ту, для которой её запускали.
// Прогон организаций 24.09: протокол новой встречи прикрепился к старому звонку.

// Отпечаток текста: у вставленного текста нет ни задачи, ни записи, и после
// перезагрузки страницы узнать его можно только по нему самому.
const textKey = (text) => (text ? `${text.length}:${text.slice(0, 80)}` : null);

/** Владелец задачи протокола: источник, запись Истории и отпечаток текста. */
export function protocolOwner(state, recordId) {
  return {
    sourceTaskId: state?.sourceTaskId || null,
    standaloneItemId: state?.standaloneItemId || null,
    recordId: recordId || null,
    textKey: textKey(state?.transcriptionText),
  };
}

/**
 * Можно ли принять результат задачи на экран с текущим источником. Задача без
 * владельца сохранена прежней сборкой — ведём себя как раньше, их век — час.
 */
export function belongsTo(owner, current) {
  if (!owner) return true;
  const same = (key) => !!owner[key] && owner[key] === current?.[key];
  return same('recordId') || same('standaloneItemId') || same('sourceTaskId') || same('textKey');
}
